import { animate, onScroll, createTimeline, stagger } from 'animejs';

export default () => {
  let typeElements = document.querySelectorAll('.home-subheading__heading');
  let timeline = createTimeline({ loop: true });

  typeElements.forEach(( heading ) => {
    animate(heading.children, {
      opacity: [0,1],
      duration: 20,
      delay: stagger(120),
      autoplay: onScroll({
        debug: false,
        enter: 'bottom+=90vh',
        leave: 'top+=10vh',
      })
    });
  });
}
